// extracted by mini-css-extract-plugin
module.exports = {"container":"badge_container__mFfBS","primary":"badge_primary__cN4A8","secondary":"badge_secondary__MRxbB","success":"badge_success__p7quZ","fill":"badge_fill__HjFfl"};